module.exports = __webpack_public_path__ + "static/img/success-bg.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/success-bg.png
// module id = 178
// module chunks = 0